<template>
  <b-navbar-nav>
    <li class="nav-item">
      <a :href="socialMediaProfiles.facebook" class="social-media-icon">
        <font-awesome-icon :icon="['fab', 'facebook']" style="font-size: 1.5em"/>
      </a>
    </li>
    <li class="nav-item">
      <a :href="socialMediaProfiles.instagram" class="social-media-icon">
        <font-awesome-icon :icon="['fab', 'instagram']" style="font-size: 1.5em"/>
      </a>
    </li>
    <li class="nav-item">
      <a :href="socialMediaProfiles.twitter" class="social-media-icon">
        <font-awesome-icon :icon="['fab', 'twitter']" style="font-size: 1.5em"/>
      </a>
    </li>
    <li class="nav-item">
      <a :href="socialMediaProfiles.tiktok" class="social-media-icon">
        <font-awesome-icon :icon="['fab', 'tiktok']" style="font-size: 1.3em"/>
      </a>
    </li>
  </b-navbar-nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SocialMedia',

  computed: {
    ...mapGetters({
      socialMediaProfiles: 'siteDataStore/socialMediaData'
    }),
  },
};
</script>

<style>
.social-media-icon {
  height: 100%;
  display: flex;
  align-items: center;

  margin: 0 0.75rem !important;
}
</style>
